import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend
} from 'recharts';

const OrdersByTableChart = ({ data }) => {
  const safeData = Array.isArray(data)
    ? data.map(d => ({
        table: d.table_name ?? 'Unknown',
        total_orders: d.total_orders ?? 0
      }))
    : [];

  // Adjust chart width based on number of tables (30px per bar)
  const chartWidth = Math.max(800, safeData.length * 30);

  return (
    <div className="overflow-x-auto">
      <div style={{ width: chartWidth }}>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={safeData}
            margin={{ top: 20, right: 30, left: 0, bottom: 60 }}
          >
            <XAxis
              dataKey="table"
              angle={-45}
              textAnchor="end"
              interval={0}
              height={80}
            />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="total_orders" fill="#60A5FA" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default OrdersByTableChart;
